import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  table: {
    background: theme.palette.background.paper,
    '& .MuiTableCell-sizeSmall ': {
      padding: '6px 6px 6px 6px',
    }
  },
  tableScrollContainer: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'scroll',
    scrollbarColor: `${theme.palette.secondary.main} ${theme.palette.background.paper}`,
    scrollbarWidth: 'thin',
    WebkitOverflowScrolling: 'touch',
    '&&::-webkit-scrollbar': { height: theme.spacing(1) },
    '&&::-webkit-scrollbar-track': { borderRadius: theme.spacing(0.5) },
    '&&::-webkit-scrollbar-thumb': {
      background: theme.palette.secondary.main,
      borderRadius: 4,
    },
    '&&::-webkit-scrollbar-thumb:hover': { background: theme.palette.secondary.dark },
  },
  titleColumn: {
    fontSize: '0.875rem',
    color: theme.palette.primary.darker,
    fontWeight: 500,
    textTransform: 'capitalize',
  },
  cursor: { cursor: 'pointer' },
  cellHeader: {
    display: 'flex',
    justifyContent: 'center'
  },
  iconSort: { color: theme.palette.secondary.main },
  pagination: { width: '100%' },
  paddingCell: {
    paddingTop: theme.spacing(1.2),
    paddingBottom: theme.spacing(1.2)
  },
  borderTopCell: {
    borderTopColor: theme.palette.input.border,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    opacity: 1
  },
  borderLeftCell: {
    borderLeftColor: theme.palette.input.border,
    borderLeftWidth: theme.spacing(0.5),
    borderLeftStyle: 'solid',
    opacity: 1
  },
  borderBottomCell: {
    borderBottomColor: theme.palette.input.border,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    opacity: 1
  },
  borderCellStyle: {
    borderColor: theme.palette.input.border,
    borderWidth: 1,
    borderStyle: 'solid',
    opacity: 1
  }
}));

export default useStyles;
